import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';

class Signout extends Component {
  componentWillMount() {
    this.props.signoutUser();
  }

  render() {
    return (
      <div>Your are now signed out. </div>
    );
  }
}

export default connect(null, actions)(Signout);



// WEBPACK FOOTER //
// ./src/containers/auth/signout.js